// First-party
import { createPage } from '@/common/util/templateHelpers';

// Component lib
import { Meta } from '@/common/components/head';

// Local
import { Block, HTMLContent, Title } from '@/common/components';
import AboutPageLayout from '@/layouts/AboutPageLayout';
import PageModel, { Page } from '@/models/Page';

interface UploadGamePageProps extends Page {
}

export default createPage<UploadGamePageProps>('UploadGamePage', {}, function UploadGamePage ({ className }, props) {
  const pageDescription = props.summary;

  const metaProps = {
    itemDescription: pageDescription,
    description: pageDescription,
    openGraph: {
      url: process.env.APP_CONFIG.URL + '/about/upload',
      description: pageDescription,
      updated_time: props.changed,
      'article:published_time': props.created,
      'article:modified_time': props.changed,
    },
    twitter: {
      description: pageDescription
    }
  };
  return (
    <AboutPageLayout className={className}>
      <Meta 
        titleTag={`${props.title} | Addicting Games`}
        title={props.title}
        {...metaProps}
      />

      <Block>
        <Title>{props.title}</Title>
        <HTMLContent html={props.body} />
      </Block>
    </AboutPageLayout>
  );
});

export async function getServerSideProps () {
  let pageData;
  try {
    pageData = await PageModel.getPage('6f3680f3-67fb-4f92-9f9f-8728461ccc91');
  } catch (err) {
    throw err;
  }
  
  return {
    props: pageData
  };
}
